import React, { useState, useEffect } from "react";
import {
  Container, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, Paper, Checkbox, Typography, Dialog,
  DialogTitle, DialogContent, IconButton, CircularProgress, Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { QRCodeSVG } from 'qrcode.react';
import { getAllBallkids, getClothingStatus, updateClothingStatus, getActiveGroupSlug } from "../firebaseService";

const ClothingDistribution = () => {
  const [ballkids, setBallkids] = useState([]);
  const [clothingStatus, setClothingStatus] = useState({});
  const [selectedBallkid, setSelectedBallkid] = useState(null);
  const [qrReady, setQrReady] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const allBallkids = await getAllBallkids();
      const sorted = allBallkids.sort((a, b) => a.name.localeCompare(b.name));
      setBallkids(sorted);

      const status = await getClothingStatus();
      setClothingStatus(status);
    };
    fetchData();
  }, []);

  // Wenn sich das ausgewählte Ballkind ändert → zurücksetzen
  useEffect(() => {
    if (selectedBallkid) {
      setQrReady(false);
      const timer = setTimeout(() => {
        setQrReady(true);
      }, 300); // leichte Verzögerung – verhindert dass alter QR-Code kurz erscheint
      return () => clearTimeout(timer);
    }
  }, [selectedBallkid?.id]);

  const handleToggle = async (ballkidId) => {
    const newStatus = !clothingStatus[ballkidId];
    await updateClothingStatus(ballkidId, newStatus);
    setClothingStatus(prev => ({ ...prev, [ballkidId]: newStatus }));
  };

  return (
    <Box>
    <Typography variant="h4" gutterBottom>
      Einkleidung
    </Typography>      
      <TableContainer component={Paper} style={{ marginTop: 20 }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell><strong>Name</strong></TableCell>
              <TableCell><strong>Kleidung erhalten</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {ballkids.map((ballkid) => (
              <TableRow
                key={ballkid.id}
                hover
                onClick={() => setSelectedBallkid(ballkid)}
                style={{ cursor: "pointer" }}
              >
                <TableCell>{ballkid.name || "Unbekannt"}</TableCell>
                <TableCell onClick={(e) => e.stopPropagation()}>
                  <Checkbox
                    checked={!!clothingStatus[ballkid.id]}
                    onChange={() => handleToggle(ballkid.id)}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* QR-Code Dialog */}
      <Dialog open={!!selectedBallkid} onClose={() => setSelectedBallkid(null)}>
        <DialogTitle>
          QR-Code für {selectedBallkid?.name}
          <IconButton
            aria-label="close"
            onClick={() => setSelectedBallkid(null)}
            style={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box display="flex" justifyContent="center" alignItems="center" minHeight={280} flexDirection="column">
            {!qrReady ? (
              <CircularProgress />
            ) : (
              <>
                <QRCodeSVG
                  value={`https://ballkid-management.de/${getActiveGroupSlug()}/member/${selectedBallkid?.id}`}
                  size={256}
                  level="H"
                  includeMargin
                />
                <Typography variant="body2" style={{ marginTop: 10 }}>
                  ID: {selectedBallkid?.id}
                </Typography>
              </>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default ClothingDistribution;
